/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Faq5q1Inputs */

const zh_pricing_faq5q1 = /** @type {(inputs: Pricing_Faq5q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`如何取消我的计划？`)
};

const en_pricing_faq5q1 = /** @type {(inputs: Pricing_Faq5q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How do I cancel my plan?`)
};

const es_pricing_faq5q1 = /** @type {(inputs: Pricing_Faq5q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cómo cancelo mi plan?`)
};

/**
* | output |
* | --- |
* | "How do I cancel my plan?" |
*
* @param {Pricing_Faq5q1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const pricing_faq5q1 = /** @type {((inputs?: Pricing_Faq5q1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Faq5q1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_pricing_faq5q1(inputs)
	if (locale === "en") return en_pricing_faq5q1(inputs)
	return es_pricing_faq5q1(inputs)
});
export { pricing_faq5q1 as "pricing_faq5Q" }